import { Component } from '@angular/core';
import { StepService } from '@lx/quote-tool/shared/services/step-service';

@Component({
  selector: 'lx-quote-error-step',
  templateUrl: './quote-error.component.html',
  styleUrls: ['./quote-error.component.scss'],
})
export class QuoteErrorComponent {
  constructor(private stepService: StepService) {}

  public goBack() {
    this.stepService.navigateToPreviousStep();
  }
}
